export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/8fdd43c4cd336df9f1b1bcbad6db376f.png";